export const cateringData = [
    'Vår meny är bara ett förslag, självklart kommer maten att tillagas efter era önskemål.',
    'Vi har samarbete med några förskolor och företag som vi laverar mat till.',
    'Vi lagar precis det ni vill ha, kör er mat var ni vill och när ni vill.',
    'Vi har egen bil med rätt utrustning för att kunna öka säkerheten och säkerställa kvalitén vid utkörningen.'
]